import { User } from 'apprise-core/user'
import { usePreload } from 'apprise-frontend-core/client/preload'
import { useAuthService } from 'apprise-frontend-iam/service'



export const userApi = "/user"
export const loggedApi = "/logged"

export const useLoggedUserCalls = () => {

    const service = useAuthService()

    const preload = usePreload()

    const self = {

        fetchLoggedUser: () => preload.get<User>(loggedApi) ?? service.at(loggedApi).get<User>()

    }

    return self;

}
